import { motion } from "motion/react";

type ActivityEntry = {
  kind: "test" | "auth" | "deploy" | "plugin" | "drift";
  message: string;
  timestamp: string;
  status: "pass" | "warn" | "fail" | "info";
};

const mockActivity: ActivityEntry[] = [
  { kind: "test", message: "mcp-bridge conformance suite passed (38/38)", timestamp: "2m ago", status: "pass" },
  { kind: "auth", message: "OIDC token refresh for workspace principal", timestamp: "4m ago", status: "info" },
  { kind: "deploy", message: "Plugin registry sync completed", timestamp: "11m ago", status: "pass" },
  { kind: "drift", message: "Schema drift detected in openai provider", timestamp: "18m ago", status: "warn" },
  { kind: "plugin", message: "mcp-filesystem v2.1.0 loaded", timestamp: "23m ago", status: "info" },
  { kind: "test", message: "Quarantine scan clean (0 violations)", timestamp: "31m ago", status: "pass" },
  { kind: "auth", message: "API key rotation scheduled", timestamp: "45m ago", status: "info" },
  { kind: "deploy", message: "Canvas surface hot-reloaded", timestamp: "1h ago", status: "pass" },
];

const kindIcon: Record<ActivityEntry["kind"], string> = {
  test: "T",
  auth: "A",
  deploy: "D",
  plugin: "P",
  drift: "~",
};

const statusColor: Record<ActivityEntry["status"], string> = {
  pass: "#50fa7b",
  warn: "#f1fa8c",
  fail: "#ff5555",
  info: "#8be9fd",
};

export function RecentActivity() {
  return (
    <div className="recent-activity">
      <div className="recent-activity__header">
        <span className="recent-activity__eyebrow">Recent Activity</span>
        <span className="recent-activity__badge">{mockActivity.length} events</span>
      </div>
      <div className="recent-activity__list">
        {mockActivity.map((entry, i) => (
          <motion.div
            key={`${entry.kind}-${entry.timestamp}`}
            className="activity-row"
            initial={{ opacity: 0, x: -12 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: i * 0.06 }}
          >
            <span
              className="activity-row__icon"
              style={{ borderColor: statusColor[entry.status] }}
            >
              {kindIcon[entry.kind]}
            </span>
            <span className="activity-row__dot" style={{ background: statusColor[entry.status] }} />
            <span className="activity-row__message">{entry.message}</span>
            <span className="activity-row__time">{entry.timestamp}</span>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
